import FormattedMessage from 'I18n/components/FormattedMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { useFlowReferences } from 'automation-ui-management/hooks/flowReferencesHook';
import { FLOW_REFERENCES_FIELDNAME } from 'automation-ui-management/queries/flowReferenceQueries';
import InboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/InboundFlowReferencesSection';
import OutboundFlowReferencesSection from 'automation-ui-management/components/workflow-references/OutboundFlowReferencesSection';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { H7 } from 'UIComponents/elements/headings';
import ReviewableSetting from 'automation-ui-canvas/containers/review/ReviewableSetting';
import * as UnenrollmentTypes from 'automation-ui-canvas/constants/UnenrollmentTypes';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectionsStep = ({
  flow
}) => {
  var _flow$classicEnrollme;
  const {
    data,
    loading
  } = useFlowReferences({
    flowId: flow.flowId,
    flowSource: PLATFORM,
    includeOutboundReferences: true
  });
  const inboundReferences = data && data[FLOW_REFERENCES_FIELDNAME] ? data[FLOW_REFERENCES_FIELDNAME].inboundReferences : [];
  const outboundReferences = data && data[FLOW_REFERENCES_FIELDNAME] ? data[FLOW_REFERENCES_FIELDNAME].outboundReferences : [];
  const loadingElement = /*#__PURE__*/_jsx(UILoadingSpinner, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformReview.v2.connectionsStep.loading"
    }),
    showLabel: true,
    layout: "centered",
    size: "small",
    grow: true
  });
  const isUnenrollmentEnabled = ((_flow$classicEnrollme = flow.classicEnrollmentSettings) === null || _flow$classicEnrollme === void 0 || (_flow$classicEnrollme = _flow$classicEnrollme.unenrollmentSetting) === null || _flow$classicEnrollme === void 0 ? void 0 : _flow$classicEnrollme.type) && flow.classicEnrollmentSettings.unenrollmentSetting.type !== UnenrollmentTypes.NONE && flow.classicEnrollmentSettings.unenrollmentSetting.type !== null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [flow.objectTypeId === CONTACT_ID && /*#__PURE__*/_jsx(UITile, {
      compact: true,
      children: /*#__PURE__*/_jsx(ReviewableSetting, {
        settingName: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "platformReview.v2.connectionsStep.unenrollmentSetting.title_cob",
          objectTypeId: flow.objectTypeId
        }),
        settingValue: !!isUnenrollmentEnabled,
        settingSectionId: "connections"
      })
    }), /*#__PURE__*/_jsx(UITile, {
      compact: true,
      style: {
        borderTopStyle: 'none'
      },
      children: /*#__PURE__*/_jsxs(UITabs, {
        defaultSelected: "usedBy",
        panelClassName: "p-x-0",
        use: "enclosed",
        hideBorders: "both",
        fill: true,
        children: [/*#__PURE__*/_jsx(UITab, {
          tabId: "usedBy",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.connectionsStep.tabs.usedBy"
          }),
          children: /*#__PURE__*/_jsx(UITileSection, {
            children: loading ? loadingElement : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "platformReview.v2.connectionsStep.tabs.usedByDescription"
                })
              }), /*#__PURE__*/_jsx(OutboundFlowReferencesSection, {
                outboundReferences: outboundReferences
              })]
            })
          })
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "usedIn",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.connectionsStep.tabs.usedIn"
          }),
          children: /*#__PURE__*/_jsx(UITileSection, {
            className: "p-bottom-0",
            children: loading ? loadingElement : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "platformReview.v2.connectionsStep.tabs.usedInDescription"
                })
              }), /*#__PURE__*/_jsx(InboundFlowReferencesSection, {
                inboundReferences: inboundReferences
              })]
            })
          })
        })]
      })
    })]
  });
};
export default ConnectionsStep;